import React from 'react';
import {Trans} from 'react-i18next';
import storeUtils from '../../../../../utils/storeUtils';
import _get from 'lodash/get';

export const deviceOptions = [
  {
    label: (
      <Trans i18nKey="p.s.u.c.preview.device.pad.portrait">
        iPad - Portrait
      </Trans>
    ),
    value: 'pad',
  },
  {
    label: (
      <Trans i18nKey="p.s.u.c.preview.device.pad.landscape">
        iPad - Landscape
      </Trans>
    ),
    value: 'padLandscape',
  },
  {
    label: (
      <Trans i18nKey="p.s.u.c.preview.device.phone.portrait">
        iPhone - Portrait
      </Trans>
    ),
    value: 'mobile',
  },
];
export const getDeviceToLabelMap = () => {
  return Object.fromEntries(deviceOptions.map(d => [d.value, d.label]));
};

export const deviceOptionsWithOutPadLandscape = deviceOptions.filter(
  device => device.value !== 'padLandscape'
);

export const getUiConfigDevice = (matchOptions, customerId) => {
  return (
    matchOptions.find(
      option =>
        option.value ===
        (storeUtils.getUiConfigSettingDevice(customerId) || matchOptions[0])
    ) || deviceOptions[0]
  );
};
export const getAvailableDevices = (deviceOptions, availableDevices = []) => {
  return deviceOptions.filter(dev => availableDevices.includes(dev.value));
};

export const setUiConfigDevice = (device, customerId) => {
  const selectedOption =
    deviceOptions.find(option => option.value === device) || deviceOptions[0];
  storeUtils.setUiConfigSettingDevice(
    customerId,
    _get(selectedOption, 'value')
  );
  return selectedOption;
};
